// The picture an offer shows when it has none (no offer photo and no business cover):
// the brand's teal with a soft light and a price tag in a frosted circle. Every offer
// card uses this one piece, so an offer without a photo looks the same — and finished —
// on the home rail, the Offers page and a business page. It fills its parent (which is
// positioned), sits under the card's own badges and says nothing to screen readers.
export function OfferArt({ className }: { className?: string }) {
  return (
    <span className={className ? `offer-art ${className}` : 'offer-art'} aria-hidden="true">
      <span className="offer-art__badge">
        <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z" />
          <circle cx="7.5" cy="7.5" r="1.5" />
        </svg>
      </span>
    </span>
  );
}
